import classNames from 'classnames';
import React, { FC, useMemo } from 'react';

import Icon, { IconProps } from '../Icon';
import noop from '@wetransfer/transfer/oneui/core/utils/noop';

import styles from './IconButton.module.scss';

export interface IconButtonProps extends IconProps {
  onClick?: () => void;
  tabIndex?: number;
  noBorder?: boolean;
  size?: number;
}

const IconButton: FC<IconButtonProps> = ({
  name,
  alt,
  onClick = noop,
  tabIndex = 0,
  size = 24,
  noBorder = false,
  className = '',
}) => {
  const buttonStyle = useMemo(() => ({ width: size, height: size }), [size]);

  return (
    <button
      className={classNames(className, styles.container, {
        [styles.containerNoBorder]: noBorder,
      })}
      onClick={onClick}
      tabIndex={tabIndex}
      data-testid={'OneUI-Icon-Button'}
      style={buttonStyle}
    >
      <Icon name={name} alt={alt} size={size} />
    </button>
  );
};

export default IconButton;
